import React from 'react';
import { Modal, Select, Upload, Icon } from 'antd';
import styles from './ProductTypeImageModal.module.css';

const Dragger = Upload.Dragger;
const { Option } = Select;

const ProductTypeImageModal = props => {
  const {
    visible,
    onCancel,
    handleSelectType,
    handleSelectPlatform,
    product_types,
    handleReset,
    handleUploadChange,
    token,
    product_type_id,
    platform,
  } = props;

  return (
    <Modal title="Upload Image" visible={visible} onCancel={onCancel} okText="Reset" onOk={handleReset}>
      <div>
        <Select
          onChange={handleSelectType}
          className={styles.Select}
          placeholder="Select Product Type"
          value={product_type_id ? product_type_id : undefined}
        >
          {product_types.map(t => (
            <Option key={t.id} value={t.id}>
              {t.title}
            </Option>
          ))}
        </Select>
        <Select
          onChange={handleSelectPlatform}
          className={styles.Select}
          placeholder="Select Platform"
          value={platform ? platform : undefined}
        >
          <Option value="android">Android</Option>
          <Option value="ios">iOS</Option>
        </Select>
      </div>
      {product_type_id && platform && (
        <Dragger
          name="files[]"
          multiple={false}
          action={`${process.env.REACT_APP_API_HOST}/cms/product_types/${product_type_id}/images?platform=${platform}`}
          headers={{ Authorization: token }}
          onChange={handleUploadChange}
        >
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
        </Dragger>
      )}
    </Modal>
  );
};

export default ProductTypeImageModal;



// WEBPACK FOOTER //
// ./src/components/ProductType/ProductTypeImageModal.js